import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';

interface Props {
  isActive: boolean;
  onEdit(): void;
}

export const ModelGroupActions: React.FC<Props> = ({ isActive, onEdit }) => {
  if (!isActive) {
    return null;
  }

  const handleEdit = evt => {
    evt.stopPropagation();

    onEdit();
  };

  return (
    <Box display="flex">
      <Button
        variant="subtleActive"
        leftIcon="fas fa-pencil-alt"
        onClick={handleEdit}
        onKeyDown={evt => evt.stopPropagation()}
        ml="4"
      >
        Edit Group
      </Button>
    </Box>
  );
};
